// src/App.js
import React, { useContext } from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, AuthContext } from "./context/AuthContext";

// Componentes
import Login from "./components/Login";
import DashboardLayout from "./pages/DashboardLayout";
import DashboardHome from "./pages/DashboardHome";
import Perfil from "./components/Perfil";
import Miembros from "./pages/Miembros";
import Prospectos from "./components/prospectos/Prospectos";
import AsistenciaClub from "./pages/AsistenciaClub"; 
import Finanzas from "./pages/Finanzas";
import FinanzasHub from "./pages/FinanzasHub";
import AsistenciaDominical from "./components/dominical/AsistenciaDominical";
import EstadisticasDominical from "./components/dominical/EstadisticasDominical";
import AsistenciaHub from "./pages/AsistenciaHub";
import Administracion from "./pages/Administracion";
import UsuariosAdmin from "./components/admin/UsuariosAdmin";
import EventosAdmin from "./components/admin/EventosAdmin";
import ManualesAdmin from "./components/admin/ManualesAdmin";
import EncuestasAdmin from "./components/admin/EncuestasAdmin";
import DocumentosOficialesAdmin from "./components/admin/DocumentosOficialesAdmin";
import CatalogosAdmin from "./pages/CatalogosAdmin";
import ProgramaMensualAdmin from "./components/admin/ProgramaMensualAdmin";
import MisionerosAdmin from "./components/admin/MisionerosAdmin";
import ClasesDominicalLeccionesAdmin from "./components/admin/ClasesDominicalLeccionesAdmin";
import ResultadosEncuestaAdmin from "./components/admin/ResultadosEncuestaAdmin";
import ReunionesAdmin from "./components/admin/ReunionesAdmin";
import HistorialAdmin from "./components/admin/HistorialAdmin";
import CampamentosAdmin from "./components/admin/CampamentosAdmin";
import ReporteAsistencia from "./pages/ReporteAsistencia";

import AdminSalidasGeneral from "./components/salidas/AdminSalidasGeneral";
import AdminSalidasMisiones from "./components/salidas/AdminSalidasMisiones";
import CartasAgradecimiento from "./pages/CartasAgradecimiento";

// 🔹 Componente para rutas privadas
function PrivateRoute({ children }) {
  const { isAuthenticated, loading } = useContext(AuthContext);

  // Mientras se verifica la sesión (cookie httpOnly), muestra un mensaje de carga
  if (loading) return <div className="p-4">Cargando...</div>;

  // Si no hay sesión activa, redirige a login
  if (!isAuthenticated) return <Navigate to="/login" />;

  return children;
}

// 🔹 Componente para rutas hijas dentro de DashboardLayout
function DashboardRoutes() {
  return (
    <DashboardLayout>
      <Outlet /> {/* Aquí se renderizan las rutas hijas */}
    </DashboardLayout>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Ruta pública */}
          <Route path="/login" element={<Login />} />

          {/* Rutas protegidas dentro del dashboard */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <DashboardRoutes />
              </PrivateRoute>
            }
          >
            <Route index element={<DashboardHome />} />
            <Route path="perfil" element={<Perfil />} />
            <Route path="miembros" element={<Miembros />} />
            <Route path="prospectos" element={<Prospectos />} />
            <Route path="asistencia/club" element={<AsistenciaClub />} />
            <Route path="finanzas" element={<FinanzasHub />} />
            <Route path="finanzas/registro-entrada" element={<Finanzas />} />
            <Route path="asistencia/escuela-dominical" element={<AsistenciaDominical />} />
            <Route path="asistencia" element={<AsistenciaHub/>}/>
            <Route path="asistencia/estadisticas" element={<EstadisticasDominical/>}/>
            <Route path="administracion" element={<Administracion/>}/>
            <Route path="administracion/usuarios" element={<UsuariosAdmin/>}/>
            <Route path="administracion/eventos" element={<EventosAdmin/>}/>
            <Route path="administracion/programa-mensual" element={<ProgramaMensualAdmin/>}/>
            <Route path="administracion/misioneros" element={<MisionerosAdmin/>}/>
            <Route path="administracion/clases" element={<ClasesDominicalLeccionesAdmin/>}/>
            <Route path="administracion/reportes" element={<ResultadosEncuestaAdmin/>}/>
            <Route path="administracion/reuniones" element={<ReunionesAdmin/>}/>
            <Route path="administracion/historial" element={<HistorialAdmin/>}/>
            <Route path="administracion/campamentos" element={<CampamentosAdmin/>}/>
            <Route path="administracion/manuales" element={<ManualesAdmin/>}/>
            <Route path="administracion/encuestas" element={<EncuestasAdmin/>}/>
            <Route path="administracion/documentos" element={<DocumentosOficialesAdmin/>}/>
            <Route path="administracion/catalogos" element={<CatalogosAdmin/>}/>
            <Route path="asistencia/reportes" element={<ReporteAsistencia />} />
            <Route path="finanzas/salida-general" element={<AdminSalidasGeneral />} />
            <Route path="finanzas/salida-misiones" element={<AdminSalidasMisiones />} />
            <Route path="finanzas/carta-agradecimiento" element={<CartasAgradecimiento />} />
          </Route>

          {/* Redirige cualquier otra ruta a login */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}